// Cache d'affichage localStorage de la conversation Kuma — borné, jamais source de vérité (le serveur l'est)
const STORAGE_KEY = "assistantConversation";
const MAX_MESSAGES = 50;

export function saveConversation<T>(messages: T[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(messages.slice(-MAX_MESSAGES)));
  } catch (e) {
    console.log(`saveConversation error: ${e}`);
  }
}

export function loadConversation<T = unknown>(): T[] {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    const parsed = saved ? JSON.parse(saved) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

// Certaines réponses du modèle sont du JSON d'aiguillage d'outil (ex. {"tool_name":"IDAssistant"},
// {"type_fraude":...,"demarches":[...]}) qui fuite en texte au lieu d'un vrai function_call.
// Une vraie réponse de Kuma est toujours du texte/markdown, jamais un objet/array JSON pur → on la masque.
export function isToolRoutingMessage(content: unknown): boolean {
  if (typeof content !== "string") return false;
  const t = content.trim();
  if (!(t.startsWith("{") && t.endsWith("}")) && !(t.startsWith("[") && t.endsWith("]"))) {
    return false;
  }
  try {
    const parsed = JSON.parse(t);
    return typeof parsed === "object" && parsed !== null;
  } catch {
    return false;
  }
}
